import * as THREE from "three";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import { EffectComposer } from "three/examples/jsm/postprocessing/EffectComposer";
import { RenderPass } from "three/examples/jsm/postprocessing/RenderPass";
import { UnrealBloomPass } from "three/examples/jsm/postprocessing/UnrealBloomPass";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";
import CircleType from 'circletype';
import { isMobileDevice } from '../config/device'
export default class EarthBg {
    animationId = "";
    pass = [];
    parentNode = null;
    circleNode = null;
    textArr = "";
    params = {
        exposure: 1.5,
        bloomStrength: 1,
        bloomThreshold: 0.1,
        bloomRadius: 2
    };
    rotateDeg = 0;
    constructor(node, textArr) {
        this.parentNode = node;
        this.textArr = textArr;
        this.main();
    }
    main() {
        this.initThree();
        this.loadModel();
        this.initControls();
        this.circleNode = this.renderCircleText();
        window.addEventListener("resize", this.resizeWindow.bind(this));
    }
    resizeWindow() {
        if (!this.parentNode) return;
        const width = this.parentNode.clientWidth;
        const height = this.parentNode.clientHeight;

        this.camera.aspect = width / height;
        this.camera.updateProjectionMatrix();

        this.renderer.setSize(width, height);
        this.composer.setSize(width, height);
    }
    initThree() {
        this.scene = new THREE.Scene();
        this.camera = new THREE.PerspectiveCamera(45, this.parentNode.clientWidth / this.parentNode.clientHeight, 0.01, 100);
        this.camera.position.set(0, 0, 6);

        this.scene.add(this.camera);
        this.renderer = new THREE.WebGLRenderer({
            antialias: true,
            alpha: true
        });
        this.renderer.setSize(this.parentNode.clientWidth, this.parentNode.clientHeight);
        this.renderer.setPixelRatio(window.devicePixelRatio);
        this.parentNode.appendChild(this.renderer.domElement);
        this.initRenderPass();

    }
    initControls() {
        this.controls = new OrbitControls(this.camera, this.renderer.domElement);
        this.controls.autoRotate = true;
        this.controls.enableZoom = false;
        this.controls.enableRotate = false;
        this.controls.enablePan = false;
        this.controls.enableKeys = false;
    }
    initRenderPass() {
        const renderScene = new RenderPass(this.scene, this.camera);
        const bloomPass = new UnrealBloomPass(new THREE.Vector2(this.parentNode.clientWidth, this.parentNode.clientHeight), 1.2, 1.2, 1);
        bloomPass.threshold = this.params.bloomThreshold;
        bloomPass.strength = this.params.bloomStrength;
        bloomPass.radius = this.params.bloomRadius;
        this.pass.push(bloomPass);
        this.pass.push(renderScene);
        this.composer = new EffectComposer(this.renderer);
        this.composer.addPass(renderScene);
        this.composer.addPass(bloomPass);
    }
    loadModel() {
        const loader = new GLTFLoader();
        //加载模型
        loader.load("/models/earth0.glb", gltf => {
            this.model = gltf.scene;
            let scale = 0;
            scale = isMobileDevice() ? 0.7 : 1.2
            this.model.scale.x = scale
            this.model.scale.y = scale
            this.model.scale.z = scale
            this.scene.add(gltf.scene);
            this.render();
        });
    }
    renderCircleText() {
        const text = this.textArr.reduce((prev, current) => {
            return prev + "&nbsp;&nbsp;" + current + "&nbsp;";
        });
        const el = document.createElement("div");
        el.innerHTML = text;
        const set_circle_style = (el) => {
            el.style.width = "10px";
            el.style.height = "10px";
            el.style.fontSize = "1em";
            el.style.position = "absolute";
            el.style.left = "50%";
            el.style.top = "50%";
            el.style.display = "flex";
            el.style.justifyContent = "center";
            el.style.alignItems = "center";
            el.style.userSelect = "none";
        };
        set_circle_style(el);
        this.parentNode.appendChild(el);
        new CircleType(el).radius(150);
        return el;
    }
    render() {
        this.rotateDeg += 0.1;
        this.animationId = requestAnimationFrame(this.render.bind(this));
        this.composer.render();
        this.controls.update();
        if (this.circleNode) {
            this.circleNode.style.transform = `translate(-50%,-50%) rotate(${this.rotateDeg}deg)`;
        }
    }
    remove() {
        cancelAnimationFrame(this.animationId);
        this.model.traverse(function (obj) {
            if (obj.type === 'Mesh') {
                obj.geometry.dispose();
                obj.material.dispose();
            }
        });
        this.pass.forEach(item => {
            this.composer.removePass(item);
        });
        this.composer.dispose();
        this.composer = null;
        this.scene.remove(this.model);
        this.scene.remove(this.camera);
        this.pass.length = 0;
        this.parentNode.innerHTML = '';
        this.renderer.forceContextLoss();
        this.renderer.dispose();
        this.scene.clear();
        this.scene = null;
        this.camera = null;
        this.renderer.domElement = null;

        THREE.Cache.clear();
        this.renderer = null;
        this.parentNode = null;
        window.removeEventListener("resize", this.resizeWindow.bind(this));
    }
}